import { render, staticRenderFns } from "./updateTag.vue?vue&type=template&id=2533f2fc&scoped=true"
import script from "./updateTag.vue?vue&type=script&lang=js"
export * from "./updateTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533f2fc",
  null
  
)

export default component.exports